import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { HomeService } from '../../../../services/home.service';
import { FinancialManagerService } from '../../../../services/financial-manager';
import Swal from 'sweetalert2';
import { UserService } from '../../../../services/user';
import { UserInterface } from '../../../../interfaces/user-interface';
import { ItemsService } from '../../../../services/items.service';
import { DeviceDetectorService } from '../../../../services/device-detector.service';

@Component({
  selector: 'app-dailyexpensespage',
  templateUrl: './dailyexpensespage.component.html',
  styleUrl: './dailyexpensespage.component.scss'
})
export class DailyexpensespageComponent {
  selectedYear!: number;
  selectedMonth!: string;
  month!: string;
  years: number[] = [];

  months = [
    { value: '01', name_ar: 'يناير', name_en: 'January' },
    { value: '02', name_ar: 'فبراير', name_en: 'February' },
    { value: '03', name_ar: 'مارس', name_en: 'March' },
    { value: '04', name_ar: 'أبريل', name_en: 'April' },
    { value: '05', name_ar: 'مايو', name_en: 'May' },
    { value: '06', name_ar: 'يونيو', name_en: 'June' },
    { value: '07', name_ar: 'يوليو', name_en: 'July' },
    { value: '08', name_ar: 'أغسطس', name_en: 'August' },
    { value: '09', name_ar: 'سبتمبر', name_en: 'September' },
    { value: '10', name_ar: 'أكتوبر', name_en: 'October' },
    { value: '11', name_ar: 'نوفمبر', name_en: 'November' },
    { value: '12', name_ar: 'ديسمبر', name_en: 'December' }
  ];

  data!: any;
  id!: any;
  contentReady: boolean = true;
  uniqueDates: string[] = [];
  filteredDate: string = '';
  allRecords: any[] = [];
  expenses: any[] = [];
  Revenues: any[] = [];
  expenseTotal!: any;
  revenueTotal!: any;
  revenueTotalCash!: any;
  expenseTotalCash!: any;
  revenueTotalOnlinePayment!: any;
  expenseTotalOnlinePayment!: any;
  filteredRecords: any;
  filteredMonth: any;
  originalRevenues: any[] = [];
  originalExpenses: any[] = [];
  isAr: boolean = localStorage.getItem("language") == "ar";
  uniqueMonths: string[] = [];
  showFinPopUp: boolean = false;
  amount!: any;
  note!: any;
  finId!: any;
  noteSearch: string = '';
  accountType!: string;
  isAdmin!: boolean;
  isMobile!: boolean;
  isSubAdmin!: boolean;
  totalAmount: number = 0;
  day: any;
  allUsers: UserInterface[] = [];
  warehouseId!: any;
  allWareHouses: any;
  amount_type!: any;
  warehouseIsStore: boolean = false;
  canShowDeliveryHeroCollecting: boolean = true;
  showExpenses: boolean = true;
  showRevenues: boolean = true;

  showDayCalendar: boolean = false;
  dayCalendarViewDate: Date = new Date();

  constructor(
    private _FinancialManager: FinancialManagerService,
    private _userService: UserService,
    private _ItemsService: ItemsService,
    private _router: Router,
    private deviceService: DeviceDetectorService,
    private _homeService: HomeService
  ) {
    const today = new Date();

    this.selectedYear = today.getFullYear();
    this.selectedMonth = (today.getMonth() + 1).toString().padStart(2, '0');
    this.day = this.formatDateForInput(today);
    this.dayCalendarViewDate = new Date(today.getFullYear(), today.getMonth(), 1);

    this.updateMonth();

    for (let y = 2015; y <= 2030; y++) {
      this.years.push(y);
    }
  }

  ngOnInit() {
    this.isMobile = this.deviceService.isMobileDevice();

    if (this.isMobile) {
      this._router.navigateByUrl('/dailyexpenses.mobile');
    }

    this.contentReady = false;
    this.warehouseId = localStorage.getItem("posId");

    this.loadWarehouseType();

    this._userService.getAccountType().subscribe({
      next: (data) => {
        this.accountType = data['user_type'];
        this.isAdmin = this.accountType == "1" || this.accountType == "10";
        this.isSubAdmin = this.accountType == "6";
      },
      error: (error) => console.error(error),
    });

    this._userService.getUserId().subscribe({
      next: (data) => {
        this.id = data['user_id'];
      },
      error: (error) => console.error(error),
    });

    this.getAllUsers();

    this.month = new Date().toISOString().slice(0, 7);
    this.getByDate();

    this._ItemsService.getWearHouses().subscribe({
      next: (res) => {
        this.allWareHouses = res.warehouse;
      },
      error: (err) => {
        console.error(err);
      },
    });
  }

  toggleExpenses() {
    this.showExpenses = !this.showExpenses;
  }

  toggleRevenues() {
    this.showRevenues = !this.showRevenues;
  }

  applyWareHouse(warehouseId: any) {
    this.warehouseId = warehouseId;
    this.loadWarehouseType();
    this.getByMonth();
  }

  private loadWarehouseType(): void {
    this._userService.getWarehouseType(Number(this.warehouseId)).subscribe({
      next: (data) => {
        const warehouseType = String(data['warehouses_type']);
        this.warehouseIsStore = warehouseType == "0";
        this.canShowDeliveryHeroCollecting = warehouseType !== "4";
      },
      error: (error) => console.error(error)
    });
  }

  onMonthYearChange() {
    this.updateMonth();
  }

  getByMonth() {
    this.contentReady = true;

    this._FinancialManager.getInbalanceByMonth(`${this.selectedYear}-${this.selectedMonth}`, this.warehouseId).subscribe(res => {
      this.Revenues = res;
      this.calculateTotal();
    });

    this._FinancialManager.getOutbalanceByMonth(`${this.selectedYear}-${this.selectedMonth}`, this.warehouseId).subscribe(res => {
      this.expenses = res;
      this.calculateTotal();
    });
  }

  getByDate() {
    this.contentReady = true;

    this._FinancialManager.getInbalanceByDate(this.day, this.warehouseId).subscribe(res => {
      this.Revenues = res;
      this.calculateTotal();
    });

    this._FinancialManager.getOutbalanceByDate(this.day, this.warehouseId).subscribe(res => {
      this.expenses = res;
      this.calculateTotal();
    });
  }

  updateMonth() {
    this.month = `${this.selectedYear}-${this.selectedMonth}`;
    console.log('الشهر المختار:', this.month);
  }

  calculateTotal() {
    let revenueTotal = 0;
    let expenseTotal = 0;
    let revenueTotalCash = 0;
    let expenseTotalCash = 0;
    let revenueTotalOnlinePayment = 0;
    let expenseTotalOnlinePayment = 0;

    this.Revenues.forEach(item => {
      const amount = parseFloat(item.amount);

      if (item.amount_type === "0") {
        revenueTotalCash += amount;
      } else {
        revenueTotalOnlinePayment += amount;
      }

      revenueTotal += amount;
    });

    this.expenses.forEach(item => {
      const amount = parseFloat(item.amount);

      if (item.amount_type === "0") {
        expenseTotalCash += amount;
      } else {
        expenseTotalOnlinePayment += amount;
      }

      expenseTotal += amount;
    });

    this.revenueTotal = revenueTotal;
    this.expenseTotal = expenseTotal;
    this.revenueTotalCash = revenueTotalCash;
    this.expenseTotalCash = expenseTotalCash;
    this.revenueTotalOnlinePayment = revenueTotalOnlinePayment;
    this.expenseTotalOnlinePayment = expenseTotalOnlinePayment;

    this.contentReady = false;
  }

  addExpenses() {
    this.showFinPopUp = true;
    this.finId = 1;
  }

  addRevenues() {
    this.showFinPopUp = true;
    this.finId = 2;
  }

  close() {
    this.finId = null;
    this.showFinPopUp = false;
  }

  onSubmit() {
    const username = localStorage.getItem("username");

    this.contentReady = true;

    const bonusPayload = {
      warehouse_id: localStorage.getItem("posId"),
      employee_id: this.id,
      username: username,
      amount: this.amount,
      amount_type: this.amount_type,
      note: this.note
    };

    if (this.finId == 1) {
      this._FinancialManager.addexpenses(bonusPayload).subscribe({
        next: () => {
          this.contentReady = false;
          this.getByMonth();
          this.close();

          Swal.fire({
            icon: 'success',
            title: this.isAr ? "تمام" : 'success',
            text: this.isAr ? "تم اضافة المصروف" : 'expenses added',
          });

          this.day = null;
        },
        error: (error) => console.error(error),
      });
    } else {
      this._FinancialManager.addRevenue(bonusPayload).subscribe({
        next: () => {
          this.contentReady = false;

          Swal.fire({
            icon: 'success',
            title: this.isAr ? "تمام" : 'success',
            text: this.isAr ? "تم اضافة الربح" : 'revenue added',
          });

          this.getByMonth();
          this.close();
          this.day = null;
        },
        error: (error) => console.error(error),
      });
    }
  }

  delete(type: any, id: any) {
    const username = localStorage.getItem("username");

    Swal.fire({
      title: this.isAr ? "متأكد؟؟" : "Are You Sure?",
      showCancelButton: true,
      confirmButtonText: this.isAr ? "اه" : "YES",
      cancelButtonText: this.isAr ? "لا" : "no"
    }).then((result) => {
      if (result.isConfirmed) {
        this.contentReady = true;

        if (type == 1) {
          this._FinancialManager.deleteRev(id, username!).subscribe({
            next: () => {
              this.contentReady = false;
              this.getByMonth();
            },
            error: (err) => console.log(err),
          });
        } else {
          this._FinancialManager.deleteEx(id, username!).subscribe({
            next: () => {
              this.contentReady = false;
              this.getByMonth();
            },
            error: (err) => console.log(err),
          });
        }
      }
    });
  }

  translateTypeEnum(type: any): string {
    switch (String(type)) {
      case "0":
        return this.isAr ? 'عمولة' : 'commission';
      case "1":
        return this.isAr ? 'راتب' : 'Salary';
      case "2":
        return this.isAr ? 'سلفه' : 'Loan';
      case "3":
        return this.isAr ? 'اوردر' : 'Order';
      case "4":
        return this.isAr ? 'توريد' : 'supply';
      default:
        return this.isAr ? '' : '';
    }
  }

  getAllUsers() {
    this.contentReady = true;

    this._homeService.getAllUsers().subscribe({
      next: (data) => {
        this.allUsers = data.filter((user: any) => user.type == 1 || user.type == 6);
        console.log(this.allUsers);
        this.contentReady = false;
      },
      error: (error) => console.error(error),
    });
  }

  userFilter(id: any) {
    const month = `${this.selectedYear}-${this.selectedMonth}`;
    const day = this.day;

    this._FinancialManager.getEmployeeBalances(id, month, day).subscribe(res => {
      this.expenses = res.outbalances;
      this.Revenues = res.inbalances;
      this.calculateTotal();
    });
  }

  getArchivedBalances() {
    this._FinancialManager.getArchivedBalances(this.warehouseId).subscribe({
      next: (data) => {
        this.Revenues = data.archived_imbalances;
        this.expenses = data.archived_outbalances;
        console.log(this.expenses);
        this.calculateTotal();
      },
      error: (err) => {
        console.error('Error loading archived balances:', err);
      }
    });
  }

  /* ================================
     Day Calendar
     ================================ */

  toggleDayCalendar(): void {
    this.showDayCalendar = !this.showDayCalendar;

    if (this.showDayCalendar) {
      const selectedDate = this.parseDateOnly(this.day);
      const baseDate = selectedDate || new Date();

      this.dayCalendarViewDate = new Date(
        baseDate.getFullYear(),
        baseDate.getMonth(),
        1
      );
    }
  }

  closeDayCalendar(): void {
    this.showDayCalendar = false;
  }

  previousDayCalendarMonth(): void {
    this.dayCalendarViewDate = new Date(
      this.dayCalendarViewDate.getFullYear(),
      this.dayCalendarViewDate.getMonth() - 1,
      1
    );
  }

  nextDayCalendarMonth(): void {
    this.dayCalendarViewDate = new Date(
      this.dayCalendarViewDate.getFullYear(),
      this.dayCalendarViewDate.getMonth() + 1,
      1
    );
  }

  getDayCalendarTitle(): string {
    return new Intl.DateTimeFormat(this.isAr ? 'ar-EG' : 'en-US', {
      month: 'long',
      year: 'numeric',
    }).format(this.dayCalendarViewDate);
  }

  getDayCalendarWeekDays(): string[] {
    return this.isAr
      ? ['الأحد', 'الإثنين', 'الثلاثاء', 'الأربعاء', 'الخميس', 'الجمعة', 'السبت']
      : ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
  }

  getDayCalendarDays(): Array<{
    date: Date;
    dayNumber: string;
    isCurrentMonth: boolean;
    isToday: boolean;
    isSelected: boolean;
    isDisabled: boolean;
  }> {
    const year = this.dayCalendarViewDate.getFullYear();
    const month = this.dayCalendarViewDate.getMonth();

    const firstDay = new Date(year, month, 1);
    const gridStart = new Date(year, month, 1 - firstDay.getDay());

    const today = new Date();
    today.setHours(0, 0, 0, 0);

    const selectedDate = this.parseDateOnly(this.day);

    return Array.from({ length: 42 }, (_, index) => {
      const date = new Date(gridStart);
      date.setDate(gridStart.getDate() + index);
      date.setHours(0, 0, 0, 0);

      return {
        date,
        dayNumber: this.isAr ? this.toArabicDigits(date.getDate()) : String(date.getDate()),
        isCurrentMonth: date.getMonth() === month,
        isToday: this.isSameDate(date, today),
        isSelected: selectedDate ? this.isSameDate(date, selectedDate) : false,
        isDisabled: false
      };
    });
  }

  selectDayCalendarDate(date: Date): void {
    const selectedDate = new Date(date);
    selectedDate.setHours(0, 0, 0, 0);

    this.day = this.formatDateForInput(selectedDate);

    this.closeDayCalendar();
    this.getByDate();
  }

  getDayDisplay(): string {
    const date = this.parseDateOnly(this.day);

    if (!date) {
      return this.isAr ? 'اختار اليوم' : 'Select day';
    }

    return new Intl.DateTimeFormat(this.isAr ? 'ar-EG' : 'en-US', {
      weekday: 'long',
      day: 'numeric',
      month: 'long',
      year: 'numeric',
    }).format(date);
  }

  private parseDateOnly(value: any): Date | null {
    if (!value) return null;

    const cleanValue = String(value)
      .replace('T', ' ')
      .replace('Z', '')
      .split('.')[0]
      .trim()
      .split(' ')[0];

    const match = cleanValue.match(/^(\d{4})-(\d{2})-(\d{2})$/);

    if (!match) return null;

    return new Date(
      Number(match[1]),
      Number(match[2]) - 1,
      Number(match[3])
    );
  }

  private isSameDate(first: Date, second: Date): boolean {
    return first.getFullYear() === second.getFullYear() &&
      first.getMonth() === second.getMonth() &&
      first.getDate() === second.getDate();
  }

  private formatDateForInput(date: Date): string {
    return [
      date.getFullYear(),
      String(date.getMonth() + 1).padStart(2, '0'),
      String(date.getDate()).padStart(2, '0'),
    ].join('-');
  }

  private toArabicDigits(value: string | number): string {
    return String(value).replace(/\d/g, (digit) => '٠١٢٣٤٥٦٧٨٩'[Number(digit)]);
  }
}